var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDualtoneMolecularinfectiondiagnostic48 = function SvgAIconDualtoneMolecularinfectiondiagnostic48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7476 39.6636C31.0146 40.5192 29.0635 41 27 41C19.8203 41 14 35.1797 14 28C14 20.8203 19.8203 15 27 15C33.502 15 38.8891 19.7734 39.8482 26.007C44.3812 26.1896 48 29.9222 48 34.5C48 39.1944 44.1944 43 39.5 43C36.7478 43 34.3011 41.692 32.7476 39.6636Z",
    fill: "#DCECFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.846 16.2504C28.8416 12.4171 24.8272 9.8009 20.2019 9.8009C13.5724 9.8009 8.19824 15.1751 8.19824 21.8045C8.19824 28.4339 13.5724 33.8081 20.2019 33.8081C20.8131 33.8081 21.4136 33.7624 22.0002 33.6743",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1982 9.80144V5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3398 10.959L26.505 8.50549",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.502 14.2129L34.3229 10.3319",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0536 10.9586L12.2256 5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9079 14.2113L8.19824 11.9994",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54845 18.9314L5.85645 18.2688",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44064 24.2041L1 25.723",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6036 29.0142L6.76562 31.8982",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6217 32.4318L12.3906 36.6842",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1982 33.8088V36.2096",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6495 21.8753C22.7206 21.8753 24.3995 20.1963 24.3995 18.1252C24.3995 16.0541 22.7206 14.3751 20.6495 14.3751C18.5784 14.3751 16.8994 16.0541 16.8994 18.1252C16.8994 20.1963 18.5784 21.8753 20.6495 21.8753Z",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8047 24.2052C15.1362 24.2052 15.4049 24.4739 15.4049 24.8054",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.21 24.8054C14.2095 24.6461 14.2726 24.4932 14.3853 24.3805C14.4979 24.2679 14.6508 24.2048 14.8101 24.2052",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7955 25.406C14.6362 25.4064 14.4833 25.3433 14.3706 25.2306C14.258 25.118 14.1949 24.9651 14.1953 24.8058",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4049 24.8058C15.4049 25.1373 15.1362 25.406 14.8047 25.406",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6531 36.0564C36.8798 36.0564 40.3062 32.63 40.3062 28.4033C40.3062 24.1766 36.8798 20.7502 32.6531 20.7502C28.4264 20.7502 25 24.1766 25 28.4033C25 32.63 28.4264 36.0564 32.6531 36.0564Z",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.876 30.5005H32.876",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.876 26.7504H35.8761",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0005 38.7507L38.0645 33.8146",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconDualtoneMolecularinfectiondiagnostic48 as ReactComponent };
export default "data:image/svg+xml;base64,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";